<template>
  <div class="widget">
      <div v-if="loading === 'form'">
          <h1>Find your Envato purchase by filling the field below</h1><br>
          <form>
              <div class="form-item">
                  <label style="text-align: center">Your Envato Market purchase code <span class="req-symbol">*</span></label>
                  <input v-validate="'required|length:36|pcode'" name="code" type="text" v-model="code" placeholder="XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX" :class="code.length > 0 ? '' : 'empty'" style="text-align: center">
                  <i class="fal fa-check-circle fa-lg"></i>
                  <span v-show="errors.has('code')" class="error"  style="text-align: center; width:100%;"><i class="far fa-exclamation-circle"></i>{{ errors.first('code') }}</span>
              </div>


              <div class="tooltip" v-show="where">
                  <div class="how large">
                      <h2>
                          Where do I find my purchase code?
                          <small>You can find the purchase code in your ThemeForest or CodeCanyon account</small>
                      </h2>
                      <div class="slider">
                          <div class="slide" v-if="slider === 0">
                              <div class="left">
                                  <img src="../assets/step1@2x.jpg"/>
                              </div>
                              <div class="right">
                                  <h3>Step 1</h3>
                                  <p>If you go to <a href="https://themeforest.net/downloads/" target="_blank">ThemeForest.net</a> or <a href="https://codecanyon.net/downloads/" target="_blank">CodeCanyon.net</a> website, you should mouse over your account name at the top and click on <a href="https://themeforest.net/downloads/" target="_blank">Downloads</a>.</p>
                              </div>
                          </div>
                          <div class="slide" v-else-if="slider === 1">
                              <div class="left">
                                  <img src="../assets/step2@2x.jpg"/>
                              </div>
                              <div class="right">
                                  <h3>Step 2</h3>
                                  <p>In your products list, you should click on the big green <strong>Download</strong> button next to the product. From the drop-down, choose <strong>License certificate & purchase code</strong>, in a PDF or TXT.</p>
                              </div>
                          </div>
                          <div class="slide" v-else>
                              <div class="left">
                                  <img src="../assets/step3@2x.png"/>
                              </div>
                              <div class="right">
                                  <h3>Step 3</h3>
                                  <p>Inside your <strong>.PDF or .TXT</strong> file you will find several info, among them the purchase code, in this format:<br><br>
                                      <u>Item Purchase Code:<br> 74f120d8-bff4-4c47-b107-cc87dc681215</u>
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div class="slider-footer">
                          <button v-if="slider >= 0 && slider < 2" class="btn-request" v-on:click.prevent="slider++">Next <i class="far fa-arrow-right" style="margin-left: .5rem"></i></button>
                          <button v-else class="btn-request" v-on:click.prevent="where = false; slider = 0">Ok, got it</button>
                      </div>
                  </div>
                  <div class="close" v-on:click.prevent="where = false"></div>
              </div>

              <button class="btn-request-large" v-on:click.prevent="validateForm">Find My Purchase <i class="far fa-arrow-right"></i></button><br>
              <a class="green-link" href="#" v-on:click.prevent="where = true">Missing purchase code?</a>

          </form>
          <div class="grey-line">
          <span>or</span>
      </div><br><br>
          <router-link to="/">Try Envato login instead?</router-link>
      </div>
      <div v-else-if="loading === 'sending'" style="min-width: 100%;">
          <h1>We are verifing your purchase</h1>
          <Spinner></Spinner>
          <p>Please wait while we verify your purchase code with Envato.</p>
      </div>
      <div v-else-if="loading === 'success'">
          <h1>Successfully Submitted Your Request </h1>
          {{product}}
      </div>
      <div v-else-if="loading === 'invalid'">
          <h1>You have entered an invalid purchase code!</h1><br>
          <img src="../assets/invalid.svg" style="max-width: 28rem;margin: 0 auto 3rem">
          <p>Please <a href="#" v-on:click.prevent="loading = 'form'">go back</a> and try again</p>
      </div>
      <div v-else-if="loading === 'error'">
          <h1>Oops, something went wrong!</h1>
          <img src="../assets/pisica.svg" style="max-width: 28rem;margin: 0 auto 3rem">
          <p>Please <router-link to="/">go back</router-link> and try again</p>
      </div>
  </div>
</template>

<script>
  /*eslint no-console: "error"*/
  import Spinner from '@/components/Spinner'
  import axios from 'axios'
  import tokensMixins from '@/mixins/tokens'
  import { Validator } from 'vee-validate';

  const dict = {
      custom: {
          code: {
              required: 'Your purchase code cannot be empty',
              length: 'Your purchase code should be exactly 36 characters'
          }
      }
  };

  Validator.extend('pcode', {
      getMessage: field => 'Invalid purchase code format',
      validate: function(v, args){
          var out = true
          var re = new RegExp("^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$")
          return re.test(v)
      }
  });

  Validator.localize('en', dict);

export default {
    name: 'Form',
    data: function(){
        var vm = this
      return {
          loading: 'form',
          ticket_id: 0,
          loader: false,
          code: '',
          where: false,
          slider: 0
      }
    },
    components: {
        Spinner
    },
    computed: {
    },
    watch: {
      where: function(nv){
          this.toggleBodyClass( nv ? 'addClass' : 'removeClass', 'noscroll')
      }
    },
    methods: {
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
        validateForm: function(){
            var vm = this
            vm.$validator.validate().then(result => {
                if (!result) {
                    // do stuff if not valid.
                } else{
                    vm.loading = 'sending'
                    axios({
                        method: 'post',
                        url: 'https://my.curlythemes.com/.netlify/functions/verifyPurchaseCode',
                        params: {
                            code: vm.code
                        }
                    })
                    .then(function (response) {
                        console.log(response)
                        if( response.status === 200 ){
                            vm.$router.push({ name: 'Products', params: { product: response.data, code: vm.code } })
                        } else if( response.status === 404 ){
                            vm.loading = 'invalid'
                        }

                        else {
                            vm.loading = 'error'
                        }
                    })
                    .catch(function (error) {
                        if( typeof error.response !== 'undefined' && typeof error.response.status !== 'undefined' && error.response.status === 404 ){
                            vm.loading = 'invalid'
                        } else {
                            vm.loading = 'error'
                        }
                    })
                }
            });
        }
    },
    mixins: [ tokensMixins ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2{
        margin-top: 0;
    }
    h2{
        font-weight: 500;
        color: #000;
    }
    .form-item{
        text-align: center;
    }
</style>
